import React from "react";
import { VIEW_MODE } from "./_common";

export default class PtoCalendarViewOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            view: VIEW_MODE.WEEK,
            viewOption: {
                showWeekend: true,
                showOnlyStaffWithLeave: false
            }
        }

        this._selectView = this._selectView.bind(this);
        this._toggleViewOption = this._toggleViewOption.bind(this);
    }

    _selectView(view) {
        const newOption = {
            ...this.state,
            view
        }
        this.setState(newOption);
        this._fireOnChange(newOption);
        this.refs.toggleButton.focus();
    }

    _toggleViewOption(optionName) {
        const newOption = {   
            ...this.state,         
            viewOption: {
                showWeekend: this.state.viewOption.showWeekend,
                showOnlyStaffWithLeave: this.state.viewOption.showOnlyStaffWithLeave
            }
        };

        newOption.viewOption[optionName] = !!!newOption.viewOption[optionName];
        this.setState(newOption);

        this._fireOnChange(newOption);

        this.refs.toggleButton.focus();
    }

    _fireOnChange(newOption) {
        if (this.props.onChange) this.props.onChange(newOption);
    }

    _voidAnchorClickHandler(evt) {
        evt.preventDefault();
        return false;
    }

    render() {

        const checkIconClass = "fa fa-check ap-horiz-margin-5";
        const blankIconClass = "fa fa-fw ap-horiz-margin-5";

        return (
            <div className="form-group-sm ap-horiz-margin-5">
                <div className="dropdown input-group input-group-sm ap-dropdown ">
                    <button style={{ width: 100 }} ref="toggleButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <span className="dropdown-label text-capitalize">{this.state.view}</span>
                            <span className="input-group-addon fa fa-caret-down ap-clickable ap-addon-button dropdown-toggler"></span>
                        </div>
                    </button>

                    <ul className="dropdown-menu" aria-labelledby="dropdownText">
                        <li className="ap-clickable ap-px-1 ap-unwrap-content" onClick={() => this._selectView(VIEW_MODE.WEEK)}><a href="#" onClick={this._voidAnchorClickHandler}>Week</a></li>
                        <li className="ap-clickable ap-px-1 ap-unwrap-content" onClick={() => this._selectView(VIEW_MODE.MONTH)}><a href="#" onClick={this._voidAnchorClickHandler}>Month</a></li>
                        <li role="separator" className="divider"></li>
                        <li className="ap-clickable ap-px-1 ap-unwrap-content" onClick={() => this._toggleViewOption("showWeekend")}>
                            <a href="#" onClick={this._voidAnchorClickHandler}>
                                <span className={this.state.viewOption.showWeekend ? checkIconClass : blankIconClass}></span><span>Show Weekends</span>
                            </a>
                        </li>
                        <li className="ap-clickable ap-px-1 ap-unwrap-content" onClick={() => this._toggleViewOption("showOnlyStaffWithLeave")}>
                            <a href="#" onClick={this._voidAnchorClickHandler}>
                                <span className={this.state.viewOption.showOnlyStaffWithLeave ? checkIconClass : blankIconClass}></span><span>Only show staff with leave</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}